import { isNativePlatform } from "@/lib/capacitor";
import { getWebBaseUrlFromEnv } from "@/lib/env";

export function getPaymentReturnUrl(
  paymentAttemptId: string,
  orderId: string,
): string {
  const params = new URLSearchParams({
    paymentAttemptId,
    orderId,
  });

  if (isNativePlatform()) {
    if (import.meta.env.PROD) {
      const universal = new URL("/payment/success", getWebBaseUrlFromEnv());
      universal.search = params.toString();
      return universal.toString();
    }

    const scheme = new URL("com.muminsmart.app://payment/success");
    scheme.search = params.toString();
    return scheme.toString();
  }

  const returnUrl = new URL("/payment/success", window.location.origin);
  returnUrl.search = params.toString();
  return returnUrl.toString();
}

/** Paths handled for native deep links (custom scheme + universal links). */
export function parsePaymentSuccessFromAppUrl(rawUrl: string): {
  paymentAttemptId: string;
  orderId: string;
} | null {
  try {
    const url = new URL(rawUrl);
    const isCustomScheme =
      url.protocol === "com.muminsmart.app:" &&
      url.hostname === "payment" &&
      url.pathname === "/success";
    const isUniversalPath =
      (url.protocol === "https:" || url.protocol === "http:") &&
      url.pathname.replace(/\/+$/, "") === "/payment/success";

    if (!isCustomScheme && !isUniversalPath) {
      return null;
    }

    const paymentAttemptId = url.searchParams.get("paymentAttemptId");
    const orderId = url.searchParams.get("orderId");

    if (!paymentAttemptId || !orderId) {
      return null;
    }

    return { paymentAttemptId, orderId };
  } catch {
    return null;
  }
}
